module.exports = __webpack_public_path__ + "static/media/assignEndApplications.d7c18080.svg";